import { render } from "./DocumentsFinances.vue?vue&type=template&id=5760c410"
import script from "./DocumentsFinances.vue?vue&type=script&lang=js"
export * from "./DocumentsFinances.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__